import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class TripService {

  constructor(
    private http: HttpClient
  ) { }

  
  getAllTrips(queryParam:any) {
    const params = new HttpParams({fromObject: queryParam});
    return this.http.get(urls.API_URL + urls.ASSIGN_TRIPS, {params})
      .pipe(catchError(errorHandl));
  }

  getOperationTrips(queryParam:any) {
    const params = new HttpParams({fromObject: queryParam});
    return this.http.get(urls.API_URL + urls.OPERATION_TRIPS, {params})
      .pipe(catchError(errorHandl));
  }

  getTripById(id: any) {
    return this.http.get(urls.API_URL + urls.ASSIGN_TRIPS + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  getTripEvents(id: any) {
    return this.http.get(urls.API_URL + urls.ASSIGN_EVENTS + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  createTrip(payload:any,tripId:any){
    if(tripId){
      return this.http.patch(urls.API_URL + urls.ASSIGN_TRIPS +'/'+tripId,payload)
      .pipe(catchError(errorHandl));
    }else{
      return this.http.post(urls.API_URL + urls.ASSIGN_TRIPS ,payload)
      .pipe(catchError(errorHandl));
    }

  }
  createStandingOrderTrip(payload: any, tripId: any) {
    if (tripId) {
      return this.http.patch(urls.API_URL + urls.STANDING_ORDER + '/' + tripId, payload)
        .pipe(catchError(errorHandl));
    } else {
      return this.http.post(urls.API_URL + urls.STANDING_ORDER, payload)
        .pipe(catchError(errorHandl));
    }

  }

  getAllStandingorder(queryParam:any) {
    const params = new HttpParams({ fromObject: queryParam });
    return this.http.get(urls.API_URL + urls.STANDING_ORDER, {params})
      .pipe(catchError(errorHandl));
  }


  getStandingorderById(id: any) {
  return this.http.get(urls.API_URL + urls.STANDING_ORDER + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  parseFile(selectedFile:any , selFundSrc:any){
    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('fundingsource', selFundSrc);
    return this.http.post(urls.API_URL + urls.PARSE_TRIPS, formData)
    .pipe(catchError(errorHandl));
  }

  assignToCompany(payload:any){
    return this.http.post(urls.API_URL + urls.ASSIGN_COMPANY ,payload)
    .pipe(catchError(errorHandl));
  }

  sendtoMarketPlace(payload: any) {
    return this.http.post(urls.API_URL + urls.ASSIGN_COMPANY, payload)
      .pipe(catchError(errorHandl));
  }

  calculateMiles(queryParam:any){
    const params = new HttpParams({ fromObject: queryParam });
    return this.http.get('https://routing.nemtplatform.com/ors/v2/directions/driving-car', {params})
    .pipe(catchError(errorHandl));
  }
   calculateFare(payload:any){
    return this.http.put(urls.API_URL + urls.ASSIGN_TRIPS + '/' + urls.FARE_ESTIMATION,payload)
      .pipe(catchError(errorHandl))
  }

    autoDistribute(payload:any){
      return this.http.post(urls.API_URL + urls.ASSIGN_TRIPS  + '/'+ urls.AUTO_DISTRIBUTE ,payload)
      .pipe(catchError(errorHandl));

  }

}
